
import { apiRequest } from '../../apiCall'


export const getNotificationCount= () => apiRequest('Notification.GetNotificationCount')



